module.exports = __webpack_public_path__ + "img/fundo_lv.db9aa0ae.jpg";